import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { UserGroup } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditUserGroup from './EditUserGroup.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        userGroup: UserGroup;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserGroupTableActions',
  props: {
    userGroup: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.userGroup }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).COMPANIES_UPDATE))
        ? (_openBlock(), _createBlock(EditUserGroup, {
            key: 0,
            "user-group": _ctx.userGroup
          }, null, 8, ["user-group"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).COMPANIES_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.user-groups.destroy', _ctx.userGroup.id),
            "query-key": [_unref(QueryKey).USER_GROUPS],
            "success-message": "user-groups.deleted",
            "error-message": "user-groups.delete.error"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})